import type { RouteRecordRaw } from "vue-router";

const defaultLocale: locale = "fr";

export interface LocalizedRoute extends Omit<RouteRecordRaw, "path" | "children"> {
  path: string;
  paths?: Partial<Record<locale, string>>;
  children?: LocalizedRoute[];
}

const generateLocalizedRoutes = (
  routes: LocalizedRoute[],
  locale: locale,
  parentPath = "",
): RouteRecordRaw[] => {
  return routes.map((route) => {
    const isDefaultLang = locale === defaultLocale;
    const localizedPath = route.paths?.[locale] || route.path;
    const fullPath = isDefaultLang
      ? `${parentPath}${localizedPath}`
      : `${parentPath === "" ? `/${locale}` : ""}${parentPath}${localizedPath}`;

    const localizedRoute = {
      ...route,
      path: fullPath,
      name: `${route.name?.toString()}:${locale}`,
      meta: { ...route.meta, locale },
    };

    if (route.children) {
      localizedRoute.children = generateLocalizedRoutes(route.children, locale, fullPath + "/");
    }

    return localizedRoute as RouteRecordRaw;
  });
};

export const localizedRoutes = (routes: LocalizedRoute[], locales: locale[]): RouteRecordRaw[] => {
  return locales.reduce((acc: RouteRecordRaw[], locale: locale) => {
    const localizedRoutes = generateLocalizedRoutes(routes, locale);

    return acc.concat(localizedRoutes);
  }, []);
};
